import { gql } from 'apollo-angular';
import { DocumentNode } from 'graphql';

export const getDeckingSections: DocumentNode = gql`
  query deckingSections {
    deckingSections(orderBy: description_ASC) {
      id
      description
      nn1
      available
      distributorEnabled
    }
  }
`;

export const getHeavyLoadTypeDefault: DocumentNode = gql`
  query getHeavyLoadTypeDefault {
    loadTypeDefault(description: "Heavy") {
      id
      liveLoad
    }
  }
`;
